<template>
  <div class="layout-footer">
    <img
      src="/assets/images/biomarketing_icon.png"
      alt="Herta Security logo"
      width="25"
    />
    <span class="footer-text" style="margin-left: 15px"
      >BioMarketing dashboard system</span
    >
  </div>
</template>

<script>
export default {
  name: "ThePanelFooter",
};
</script>
